/* eslint-disable react-hooks/exhaustive-deps */
import { Column } from '@access-erp/common';
import { CellType } from '@access-erp/ui-components';
import { useMemo } from 'react';

const baseConfig = {
  suppressAdvancedFilter: true,
};

export const useDetailColumns = () => {
  const detailColumns: Column<any>[] = [
    {
      name: 'customerName',
      caption: 'Account Name',
      width: 200,
      cellType: CellType.String,
      filterable: true,
      ...baseConfig,
    },
    {
      name: 'customerAccountNumber',
      caption: 'Account Number',
      cellType: CellType.String,
      width: 150,
      ...baseConfig,
    },
    {
      name: 'contractVolume',
      caption: 'Contract Volume',
      cellType: CellType.Integer,
      width: 200,
      ...baseConfig,
    },
  ];

  return useMemo(() => ({ detailColumns }), []);
};
